// Terms of Use / Privacy Policy acceptance (v3_97).
//
// The server is authoritative. Acceptance is deliberately NOT cached in localStorage — the existing
// `id_portfolio_prompt_seen_*` pattern is right for a UI nudge and wrong for a legal record, because
// a record that lives in the browser is a record that can be cleared, and one that can be cleared is
// not evidence. Every check goes to /api/legal/pending.
import axiosInstance from "../api/axios";

// What this caller must still accept. `isBlocked: false` means render no gate at all.
export const getPendingLegal = () => axiosInstance.get(`/legal/pending`);

// Record agreement. The hash of each document is sent back so the server can refuse an acceptance
// of text that has changed since the page was opened.
export const acceptLegal = (acceptances, extra = {}) =>
  axiosInstance.post(`/legal/acceptances`, { acceptances, platform: "WEB", ...extra });

export const getMyLegalAcceptances = () => axiosInstance.get(`/legal/acceptances/me`);

// Public — readable without an account, which is what a store reviewer and a signed-out reader need.
export const getPublicLegalDocument = (docType, persona) =>
  axiosInstance.get(`/public/legal/${docType}`, { params: persona ? { persona } : {} });

// --- Zumale admin ---
export const publishLegalDocument = (payload) => axiosInstance.post(`/admin/legal/documents`, payload);
export const getLegalAcceptanceAudit = (params) =>
  axiosInstance.get(`/admin/legal/acceptances`, { params });

// A tick from somebody with no account, recorded against the link they arrived on (v4_5).
// Never throws the caller off course: if nothing is published yet the server records nothing and
// says so, because a vendor blocked from quoting by unpublished Terms would be an outage we caused.
export const recordTokenAcceptance = (token, subjectType, subjectId) =>
  axiosInstance.post(`/public/legal/token-acceptances`, { token, subjectType, subjectId });
